module.exports = __webpack_public_path__ + "img/gender.8d0c38aa.svg";